import { ENDPOINTS } from '../../constants/api'
import { madeRequest } from '../../helpers/api'
import { replaceRouteParams } from '../../helpers/url'

// PLOP_APPEND_PATTERN_ANCHOR

export function getRightsService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.rights
  })
}

export function getRightService(id, isAsyncMode) {
  return madeRequest('GET', {
    url: `${isAsyncMode ? ENDPOINTS.rightsAsync : ENDPOINTS.rights}${id}/`
  })
}

export function createRightService(data) {
  return madeRequest('POST', {
    data,
    url: ENDPOINTS.rights
  })
}

export function updateRightService(id, data, method = 'PATCH') {
  return madeRequest(method, {
    data,
    url: `${ENDPOINTS.rights}${id}/`
  })
}

export function deleteRightService(id) {
  return madeRequest('DELETE', {
    url: `${ENDPOINTS.rights}${id}/`
  })
}

export function getRightSuggestedChangesService(id) {
  return madeRequest('GET', {
    url: replaceRouteParams(ENDPOINTS.rightSuggestedChanges, { id })
  })
}

export function applyRightSuggestedChangesService(id) {
  return madeRequest('POST', {
    url: replaceRouteParams(ENDPOINTS.rightApplySuggestedChanges, { id })
  })
}

export function getPartnerbrainHistoryService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.partnerbrainHistory
  })
}

export function getRightSocialPostsService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.rightSocialPosts
  })
}

export function getGoogleAdManagerPlacementsService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.googleAdManagerPlacements
  })
}

export function getGoogleAdManagerLabelsService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.googleAdManagerLabels
  })
}

export function getGoogleAdManagerCustomFieldsService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.googleAdManagerCustomFields
  })
}

export function getGoogleAdManagerConstantsService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.googleAdManagerConstants
  })
}

export function getGoogleAdManagerAudienceSegmentsService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.googleAdManagerAudienceSegments
  })
}

export function getGoogleAdManagerCustomTargetingService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.googleAdManagerCustomTargeting
  })
}

export function getGoogleAdManagerCmsMetadataService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.googleAdManagerCmsMetadata
  })
}
